<template>
  <div>
    <validation-observer ref="registerRKIDebtorRules">
      <b-form>
        <b-row>
          <b-col md="12">
            <b-form-group
              :label="$t('DEBTIA_REASON')"
              label-for="reasons"
            >
              <v-select
                v-model="reason"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="reasons"
                :reduce="val => val.value"
                :clearable="false"
                input-id="reasons"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
          >
            <b-button
              variant="primary"
              type="submit"
              class="addAwaitBtn"
              @click.prevent="submitForm"
            >
              {{ $t('DEBTIA_SUBMIT') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import {
  // BFormInput,
  BButton,
  BForm,
  BRow,
  BCol,
  BFormGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'

export default {
  components: {
    // BCardCode,
    BForm,
    BRow,
    BCol,
    BButton,
    ValidationObserver,
    vSelect,
    BFormGroup,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      courtsOptions: [],
      reasons: [
        { label: 'BET-Fordring betalt', value: 'BET' },
        { label: 'AIN-Aftale indgået med skyldner', value: 'AIN' },
        { label: 'DØD-Skyldner er afgået ved døden', value: 'DØD' },
        { label: 'TFY-Tvangsakkord fyldestgjort', value: 'TFY' },
        { label: 'GAL-Gældssanering – al gæld bortfalder', value: 'GAL' },
        { label: 'VTT-Varen taget retur', value: 'VTT' },
        { label: 'TAF-Tvangsauktion aflyst', value: 'TAF' },
        { label: 'STR-Der er strid i sagen', value: 'STR' },
        { label: 'DER-Andet – vi ønsker skyldner slettet', value: 'DER' },
      ],
      reason: '',
    }
  },
  methods: {
    async submitForm() {
      const processID = this.$route.params.id
      const dataObj = {
        process_id: Number(processID),
        module_id: 21,
        module_order: 1,
        reason: this.reason,
      }
      if (this.conditionObject.moduleID > 0) {
        dataObj.depends_on = this.conditionObject.moduleID
        dataObj.condition = this.conditionObject.type
      }
      await this.$refs.registerRKIDebtorRules.validate().then(success => {
        if (success) {
          const url = '/process/module/add'
          axios.post(url, dataObj).then(response => {
            if (response.status === 200) {
              const returnObj = {
                parentID: this.conditionObject.parentID,
                depend: dataObj.depends_on,
              }
              returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
              this.$emit('closeRegisterRKIModal', returnObj)
            }
          }).catch(e => {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Error',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: e.response.data.message[0],
              },
            })
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .addAwaitBtn {
    width: 100%;
  }
</style>
